import { Outlet } from "react-router-dom";
import LeftPanel from "../../components/LeftPanel/LeftPanel";
import { MainContent } from "../../styles/components/MainContent.styled";
import * as styled from "./StudentManager.styled"

const navList = [
  { name: 'Головна', link: "general"},
  { name: "Чат", link: "chat" },
  { name: "Мої учні", link: "my-students" },
];
function StudentManager(){
  return (
    <styled.Wrapper>
      <LeftPanel
        pageTitle={`Manager‘s Room`}
        navList={navList}
        currentRoute={"/manager"}
      />

      <MainContent>
        <Outlet />
      </MainContent>
    </styled.Wrapper>
  )
};

export default StudentManager;
